module.exports = __webpack_public_path__ + "img/SALE.c6a56137.svg";